import { createContext } from "react"

export const initialStateContext = {}
const initialDispatchContext = {}

export const ReportStateContext = createContext(initialStateContext)
export const ReportDispatchContext = createContext(initialDispatchContext)
